import { toCurrency } from "@/utils/to-currency";
import {
  GST_PERCENTAGE,
  type PricingBreakdown,
} from "@/utilities/tax-constants";

interface PricingBreakdownProps {
  breakdown: PricingBreakdown;
  className?: string;
}

export default function PricingBreakdown({
  breakdown,
  className = "",
}: PricingBreakdownProps) {
  if (!breakdown) return null;

  return (
    <div className={`pricing-breakdown ${className}`}>
      <div className="w-full px-3 py-2 border border-gray-200 bg-gray-50 rounded-md space-y-1">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Subtotal:</span>
          <span>{toCurrency(breakdown.subtotalDisplay)}</span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-gray-600">GST ({GST_PERCENTAGE}%):</span>
          <span>{toCurrency(breakdown.gstDisplay)}</span>
        </div>

        <div className="flex justify-between text-base font-semibold pt-1 border-t border-gray-200">
          <span>Payable Amount:</span>
          <span className="text-gray-600">
            {toCurrency(breakdown.totalDisplay)}
          </span>
        </div>
      </div>
    </div>
  );
}